// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LogoSvg from "../../assets/logo.svg";
import * as GithubSvg from "../../assets/github.svg";

var make = LogoSvg.ReactComponent;

var Logo = {
  make: make
};

var make$1 = GithubSvg.ReactComponent;

var GitHubIcon = {
  make: make$1
};

function rs(prim) {
  return prim;
}

function Navbar(Props) {
  return React.createElement("section", {
              className: "navbar"
            }, React.createElement("div", {
                  className: "empty"
                }), React.createElement("a", {
                  className: "brand",
                  href: "/"
                }, React.createElement(make, {
                      role: "logo",
                      className: "brand-logo"
                    })), React.createElement("nav", {
                  className: "navbar-menu"
                }, React.createElement("a", {
                      className: "github-link",
                      title: "My GitHub",
                      href: "https://github.com/fa7ad",
                      target: "_blank"
                    }, React.createElement(make$1, {
                          className: "icon github"
                        }), "@fa7ad")));
}

var make$2 = Navbar;

export {
  Logo ,
  GitHubIcon ,
  rs ,
  make$2 as make,
  
}
/* make Not a pure module */
